import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { shareReplay } from 'rxjs/operators';
import { HttpRequestMethods, IDP_APPS } from '../../constants/utils';
import { EndpointKeysCommon } from '../../constants/utils/app.constants';
import {
  HeaderFooterAEM,
  HttpHeadersPayload,
  ReplaceItem
} from '../../models/utils';
import {
  ApiBuilder,
  AppConfigService,
  ExtendedCookieHelperUtilsService,
  handleError
} from '../../services/utils';
import { ApplicationConfig } from '../../utils/config';
import { UrlUtil } from '../../utils/url/urlUtil';

@Injectable({
  providedIn: 'root'
})
export class HeaderFooterContentService {
  http = inject(HttpClient);
  config = inject(AppConfigService);
  appConfig = inject(ApplicationConfig);
  urlUtils = inject(UrlUtil);
  countryCodeFromPrefUI = '';
  headerFooterJson!: Observable<HeaderFooterAEM>;
  cookieHelperService = inject(ExtendedCookieHelperUtilsService);

  private headerInfo: HttpHeadersPayload = {
    'Content-Type': 'application/json'
  };

  _errorHandler = handleError.bind(this);

  getHeaderFooterContent = (): Observable<HeaderFooterAEM> => {
    if (this.headerFooterJson) {
      return this.headerFooterJson;
    } else {
      this.headerFooterJson = this.initAPI().pipe(shareReplay(1));
      return this.headerFooterJson;
    }
  };

  initAPI = (): Observable<HeaderFooterAEM> => {
    this.getCountryCode();

    let url = this.appConfig.get('APP_CONTENT_CONFIG_URL');
    url = url.replace(
      '{param1}',
      this.urlUtils.getCountryCodeForUrl(this.countryCodeFromPrefUI)
    );

    const finalUrl: ReplaceItem[] = [
      {
        src: '/content/dam/delta-applications/login/auth-config.json',
        target: url
      }
    ];

    return new ApiBuilder<undefined, HeaderFooterAEM>(this.http, this.config)
      .app(IDP_APPS.COMMON)
      .endpointKey(EndpointKeysCommon.APP_AUTH_CONFIG_JSON)
      .overrideEndpoint(finalUrl)
      .method(HttpRequestMethods['GET'])
      .httpHeaders(this.headerInfo)
      .errorHandler(this._errorHandler)
      .library('SITE_WIDE_HEADER_FOOTER')
      .create();
  };

  getCountryCode = (): string => {
    this.countryCodeFromPrefUI = this.cookieHelperService.getCookies('prefUI');
    const splitCookieValue =
      this.countryCodeFromPrefUI && this.countryCodeFromPrefUI.length > 0
        ? this.countryCodeFromPrefUI.split('=')[1]?.split('-')[1]?.toLowerCase()
        : null;

    if (!splitCookieValue) {
      this.countryCodeFromPrefUI = this.getDefaultCountry();
    } else {
      this.countryCodeFromPrefUI = splitCookieValue;
    }
    return this.countryCodeFromPrefUI;
  };

  getDefaultCountry(): string {
    return this.appConfig.get('APP_DEFAULT_COUNTRY')
      ? this.appConfig.get('APP_DEFAULT_COUNTRY')
      : 'us';
  }
}
